import { MEASUREMENT_SYSTEM_CONTEXT_ID } from '@app-modules/site-context/constants/measurement-system-context-id.constant';

export const CONTEXT_CONFIG = {
  currency: [
    'EUR',
    'GBP',
    'USD',
    'JPY',
    'CZK',
    'HUF',
    'PLN',
    'BRL',
    'CNY',
    'DKK',
    'INR',
    'MXN',
    'NOK',
    'SEK',
    'AUD',
    'KRW',
    'VND',
    'THB',
    'IDR'
  ],
  urlParameters: ['baseSite', 'language'],
  baseSite: [
    'uk-ie',
    'cz',
    'global',
    'de',
    'hu',
    'pl',
    'ru',
    'sk',
    'tr',
    'ua',
    'br',
    'cee',
    'be',
    'br',
    'ca',
    'cn',
    'dk',
    'exp',
    'fi',
    'fr',
    'ib',
    'in',
    'it',
    'mx',
    'nl',
    'no',
    'se',
    'us',
    'nafta',
    'jap',
    'inm',
    'wee',
    'kr',
    'roa',
    'id',
    'th',
    'vi'
  ],
  [MEASUREMENT_SYSTEM_CONTEXT_ID]: ['metric', 'imperial']
};
